webpackJsonp([114276838955818,60335399758886],{

/***/ 176:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Paul Conrad Architects","description":"","keywords":"","url":"https://www.conradarchitects.com"}},"wordpressOptions":{"meta_description_default":"Paul Conrad Architects believes in the power of architecture and interior design to enhance our lives and the cities in which we live."}},"layoutContext":{}}

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(382);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(176);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\t\tpadding-top: ', 'px;\n\t'], ['\n\t\tpadding-top: ', 'px;\n\t']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(296);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _components = __webpack_require__(11);
	
	var _global = __webpack_require__(6);
	
	var _utils = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Layout = function Layout(_ref) {
	    var children = _ref.children,
	        data = _ref.data,
	        location = _ref.location;
	    return _react2.default.createElement(
	        SiteWrapper,
	        {
	            id: 'site-wrapper'
	        },
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: data.site.siteMetadata.title,
	
	            meta: [{ name: 'description', content: data.wordpressOptions.meta_description_default }, { name: 'keywords', content: data.site.siteMetadata.keywords }, { property: 'og:url', content: data.site.siteMetadata.url },
	            //{ property: 'og:image', content: ogProfileImage },
	            { property: 'og:title', content: data.site.siteMetadata.title }, { property: 'og:description', content: data.wordpressOptions.meta_description_default }, { property: 'twitter:card', content: 'summary' }, { property: 'twitter:title', content: data.site.siteMetadata.title }, { property: 'twitter:description', content: data.wordpressOptions.meta_description_default }]
	        }),
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover' }),
	            _react2.default.createElement('meta', { name: 'facebook-domain-verification', content: '0koso2adnmg0mzt3wu58a4iugp6zce' }),
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', charset: 'UTF-8', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css' }),
	            _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css' }),
	            _react2.default.createElement('script', { src: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/1.11.1/TweenLite.min.js' }),
	            _react2.default.createElement('meta', { name: 'google-site-verification', content: 'cMtKnIO9mU5X2m766CxIQahSYnkajwMfvACnieAcZes' }),
	            _react2.default.createElement('meta', { name: 'google-site-verification', content: '046E-7clONn2iajBlvtwCVxmViCI2dIkXuQpwy2iRbI' })
	        ),
	        _react2.default.createElement(_components.ScrollBackground, {
	            location: location
	        }),
	        _react2.default.createElement(_components.Splash, {
	            location: location
	        }),
	        _react2.default.createElement(_components.Header, {
	            location: location
	        }),
	        children()
	    );
	};
	
	var SiteWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'layouts__SiteWrapper',
	    componentId: 'wjj3bf-0'
	})(['height:100%;display:flex;flex-direction:column;align-items:center;padding-top:', 'px;> *:first-child{transition:background-color 0.1s ease-out;}', ' ', ''], _global.headerHeight.desktop, _utils.media.laptop(_templateObject, _global.headerHeight.laptop), _utils.media.phone(_templateObject, _global.headerHeight.phone));
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-b8122cbd820c93b8bcec.js